<template>
    <div class="my-2 container" v-loading="isLoading">
        <div style="padding: 10px 0px;">
            <el-form ref="form" :model="formStandard" label-width="120px" class="w-100">
                <div class="card data-table mb-5 mb-xl-10 w-100">
                    <div class="card-header">
                        <div
                            style="padding: 10px ; display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <span><i class="fas fa-truck" /> Giao hàng tiêu chuẩn</span>
                            <el-switch v-model="formStandard.odooIsPublished" />
                        </div>
                    </div>
                    <div style="padding: 10px;">
                        <div style="display: flex; gap: 20px; margin-bottom: 15px; align-items: center;">
                            <span>Phí vận chuyển</span>
                            <el-input-number v-model="formStandard.nMucGia"  :min="0" style="width: 30%;" />
                        </div>
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <el-checkbox v-model="formStandard.odooFreeOver" /><span>Phí vận chuyển miễn phí</span>
                        </div>
                        <div v-if="formStandard.odooFreeOver">
                            <p style="font-size: 13px; margin-bottom: 0px;">Áp dụng phí vận chuyển miễn phí khi tổng giá
                                trị đơn hàng lớn hơn hoặc bằng</p>
                            <el-input-number v-model="formStandard.odooAmount"  :min="0"
                                style="width: 430px;" />
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
        <div style="padding: 10px 0px;">
            <el-form ref="form" :model="formExpress" label-width="120px" class="w-100">
                <div class="card data-table mb-5 mb-xl-10 w-100">
                    <div class="card-header">
                        <div
                            style="padding: 10px ; display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <span><i class="fas fa-shipping-fast" /> Giao hàng nhanh(Express)</span>
                            <el-switch v-model="formExpress.odooIsPublished" />
                        </div>
                    </div>
                    <div style="padding: 10px;">
                        <div style="display: flex; gap: 20px; margin-bottom: 15px; align-items: center;">
                            <span>Phí vận chuyển</span>
                            <el-input-number v-model="formExpress.nMucGia"  :min="0" style="width: 30%;" />
                        </div>
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <el-checkbox v-model="formExpress.odooFreeOver" /><span>Phí vận chuyển miễn phí</span>
                        </div>
                        <div v-if="formExpress.odooFreeOver">
                            <p style="font-size: 13px; margin-bottom: 0px;">Áp dụng phí vận chuyển miễn phí khi tổng giá
                                trị đơn hàng lớn hơn hoặc bằng</p>
                            <el-input-number v-model="formExpress.odooAmount"  :min="0"
                                style="width: 430px;" />
                        </div>
                        <!-- Button -->
                    </div>
                </div>
            </el-form>
        </div>
        <div style="text-align: right; padding: 10px 0px;">
            <el-button type="primary" @click="handleSave()">
                Lưu
            </el-button>
        </div>
    </div>
</template>
<script>
import { Transportation } from '@/store/enums/StoreEnums';
import { useStore } from 'vuex';
import { ElMessage } from "element-plus";
export default {
    data() {
        return {
            store:useStore(),
            size: "",
            isLoading: false,
            formStandard: {
                nMucGia: "",
                cTenPhuongThucVanChuyen: "Giao hàng tiêu chuẩn",
                odooIsPublished: false,
                odooFreeOver: false,
                odooAmount: 0,
                nType: 0
            },
            formExpress: {
                nMucGia: "",
                cTenPhuongThucVanChuyen: "Giao hàng nhanh",
                odooIsPublished: false,
                odooFreeOver: false,
                odooAmount: 0,
                nType: 1
            }
        };
    },
    methods: {
        async handleSave() {
            this.isLoading = true
            let formS = Object.assign({}, this.formStandard)
            let formE = Object.assign({}, this.formExpress)
            formS.odooIsPublished = formS.odooIsPublished ? 1 : 0
            formS.odooFreeOver = formS.odooFreeOver ? 1 : 0

            formE.odooIsPublished = formE.odooIsPublished ? 1 : 0
            formE.odooFreeOver = formE.odooFreeOver ? 1 : 0

            const arr = [formS, formE]

            const res = await this.store.dispatch(Transportation.saveShippingMethod,arr);
            if (res.code == 200) {

                ElMessage({ message: "Thành công", type: "success" });

            } else {
                ElMessage({ message: "Thất bại", type: "error" });
            }
            this.isLoading = false
            this.getShippingMethod()
        },

        async getShippingMethod() {
            const res = await this.store.dispatch(Transportation.getShippingMethod)
            if (res.code == 200) {
                res.data.forEach(element => {
                    if (element.nType === 0) {
                        this.formStandard = {
                            ...element,
                            odooIsPublished: element.odooIsPublished === 1 ? true : false,
                            odooFreeOver: element.odooFreeOver === 1 ? true : false
                        }
                    }
                    else if (element.nType === 1) {
                        this.formExpress = {
                            ...element,
                            odooIsPublished: element.odooIsPublished === 1 ? true : false,
                            odooFreeOver: element.odooFreeOver === 1 ? true : false
                        }
                    }
                });
            }
        }
    },
    mounted() {
        this.getShippingMethod()
    },
};
</script>
<style lang="scss" scoped>
.tbl {
    height: calc(100vh - 255px);
}

.box-card {
    margin: 10px;
}
</style>
